import { Link } from '@platform/ui-kit'
import { JUNGLE_FINANCIAL_SUPPORT_EMAIL, nestLayout } from '@platform/utils'
import { FAQLayout, WebsiteAccordionFAQ, WebsitePageLayout } from '@platform/website-components'
import type { ReactElement } from 'react'

import styles from './styles.module.scss'

const ACCORDION_COMPANIES_ITEMS = [
  {
    headerText: 'What is Olby?',
    children: (
      <p className={styles['content-text']}>
        Olby is a tech-enabled community to hire engaging talent from Brazil. We provide our talent,
        individually or as a team, to companies that need help scaling or leading their engineering
        team.
      </p>
    ),
  },
  {
    headerText: 'How soon can Olby talent join my team? ',
    children: (
      <p className={styles['content-text']}>
        This can range from a few days to a few weeks and will mostly depend on your requirements.
      </p>
    ),
  },
  {
    headerText: "Can I interview Olby's Talent?",
    children: (
      <p className={styles['content-text']}>
        Yes. Our matching process includes at least a 30-minute call so talent and company can get
        to know each other. We also allow for customized multi-step interview processes. However, we
        encourage you to trust our vetting process and keep it simple. If the talent does not meet
        your expectations during the initial two weeks, you pay nothing.
      </p>
    ),
  },
  {
    headerText: 'How do payments work?',
    children: (
      <p className={styles['content-text']}>
        The company pays Olby through our simple monthly billing, and Olby pays the talent. We
        accept Domestic and International wire transfers. Please email{' '}
        <Link className={styles['link']} href={`mailto:${JUNGLE_FINANCIAL_SUPPORT_EMAIL}`}>
          {JUNGLE_FINANCIAL_SUPPORT_EMAIL}
        </Link>{' '}
        for more information.
      </p>
    ),
  },
  {
    headerText: 'Do you provide talent on part-time basis talent?',
    children: (
      <p className={styles['content-text']}>
        Our talent normally join our partners on a full-time, fully dedicated basis. 
        This being said, if you’re interested in building a long-term partnership 
        that starts with part-time talent, we’re down to chat.
      </p>
    ),
  },
  {
    headerText: 'How do I hire talent?',
    children: (
      <p className={styles['content-text']}>
        Please, visit{' '}
        <Link
          className={styles['link']}
          href={`${process.env.NEXT_PUBLIC_COMPANY_URL}/sign-up`}
          prefetch={false}
          isExternal
        >{`${process.env.NEXT_PUBLIC_COMPANY_URL}/sign-up`}</Link>{' '}
        to get started.
      </p>
    ),
  },
]

export const FAQCompanies = () => {
  return <WebsiteAccordionFAQ title="For companies" content={ACCORDION_COMPANIES_ITEMS} />
}

const getLayout = (page: ReactElement) => <FAQLayout>{page}</FAQLayout>

export const FAQCompaniesLayout = nestLayout({
  parent: WebsitePageLayout,
  child: getLayout,
})

FAQCompanies.getLayout = FAQCompaniesLayout

export default FAQCompanies
